import { GoogleAnalytics4EventNames } from '../../AnalyticsEventNames';
import AnalyticsEvent from './AnalyticsEvent';

class ShippingInfo extends AnalyticsEvent {
  /**
   * @param {Object} shippingInfo
   * @param {Array.<AnalyticsItem>} shippingInfo.productList
   * @param {string} shippingInfo.currencyCode
   * @param {number} shippingInfo.value
   */
  sendShippingInfoEvent({ productList, currencyCode, value }) {
    const { campaignCodeStore, checkoutStore } = this.rootStore;
    const activeCoupon = campaignCodeStore.activeCoupon;
    const coupon = activeCoupon && !activeCoupon.hasProductLimitations && activeCoupon || null;
    const order = checkoutStore.order;

    const data = {
      ecommerce: {
        coupon,
        currency: currencyCode,
        shipping_tier: order?.selected_shipping?.module?.name || null,
        value,
        items: productList.map((item) => this.item.analyticsItemToItem({
          product: item,
          quantity: item.quantity,
          activeProductId: item.id,
        }, true)
        ),
      },
    };

    this.dataLayer.pushEventToDataLayer(
      data,
      GoogleAnalytics4EventNames.addShippingInfo,
    );
  }
}

export default ShippingInfo;
